/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Log_Status_SentInputs */

const he_account_delivery_log_status_sent = /** @type {(inputs: Account_Delivery_Log_Status_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נשלח`)
};

const en_account_delivery_log_status_sent = /** @type {(inputs: Account_Delivery_Log_Status_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Account_Delivery_Log_Status_SentInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_log_status_sent = /** @type {((inputs?: Account_Delivery_Log_Status_SentInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Log_Status_SentInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_log_status_sent(inputs)
	return en_account_delivery_log_status_sent(inputs)
});